import { useSelector } from 'react-redux';
import { get } from 'lodash';
import * as loadingSelector  from '../slices/loading/selector';
import { serviceSelector } from '../slices/service';
import { loginSelector } from '../slices/login';
import { regionSelector } from '../slices/region';
import { provinceSelector } from '../slices/province';
import { municipalitySelector } from '../slices/municipality';
import { barangaySelector } from '../slices/barangay';
import { transactionSelector } from '../slices/transaction';
import { transactionTypeSelector } from '../slices/transaction-type';
import { ownershipTypeSelector } from '../slices/ownership-type';
import { serviceTypeSelector } from '../slices/service-type';
import { routeSelector } from '../slices/route';
import { transactionTypeRequirementSelector }  from '../slices/transaction-type-requirement';
import { applicationSelector } from '../slices/application';
import { paymentSelector } from '../slices/payment';
import { appointmentSelector } from '../slices/appointment';
import { branchSelector } from '../slices/branch';

const combiedSelector = {
  loading: loadingSelector,
  service: serviceSelector,
  auth: loginSelector,
  region: regionSelector,
  province: provinceSelector,
  municipality: municipalitySelector,
  barangay: barangaySelector,
  transaction: transactionSelector,
  transactionType: transactionTypeSelector,
  ownershipType: ownershipTypeSelector,
  serviceType: serviceTypeSelector,
  route: routeSelector,
  transactionTypeRequirement: transactionTypeRequirementSelector,
  application: applicationSelector,
  payment: paymentSelector,
  appointment: appointmentSelector,
  branch: branchSelector
}

const useSelect = (path, props) => {
    return useSelector(state => get(combiedSelector, path)(state, props))      
}

export default useSelect